<script setup lang="ts">
interface Props {
  type: 'main' | 'accent' | 'error' | 'error-strong' | 'warning'
}
defineProps<Props>()
</script>

<template>
  <div class="message-box pd-rect bd-1px" :class="type">
    <slot />
  </div>
</template>

<style scoped>
/* CSS Here */
.message-box {
  display: inline-block;
  font-weight: var(--font-weight-medium);
}

.main {
  color: var(--main);
  background: var(--text-bg-main);
}

.accent {
  color: var(--accent);
  background: var(--text-bg-accent);
}

.error {
  color: var(--error);
  background: var(--text-bg-error);
}

.error-strong {
  color: var(--pure-white);
  background: var(--text-bg-error-strong);
}

.warning {
  color: var(--warning);
  background: var(--text-bg-waring);
}
</style>
